module.exports = __webpack_public_path__ + "assets/img/warrior-name-972c610a.png";